export default __webpack_public_path__ + "locales/lv/PeopleTranslations.json?hash=27bccc5abb719a7a532dd0a981a39de4";